import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelayGreen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 9.75,
			r: 6.25,
			stroke: "#00AA84",
			strokeWidth: 1.2,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 6.75V9.75L10.35 11",
			stroke: "#00AA84",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.35 12.85L13.55 15.05L17.1 10.55",
			stroke: "#00AA84",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDelayGreen);
export { ForwardRef as ReactComponent };
